import { OrderSelectionBackend } from '../use-short-code/types';

export enum ShortCodePollingStatus {
  None = 'None',
  Pending = 'Pending',
  Processing = 'Processing',
  Confirmed = 'Confirmed',
  NotFound = 'NotFound',
}

export interface IUseShortCodePollStatusParams {
  loyaltyId?: string;
  shortCode?: string;
  skipPolling: boolean;
  pollInterval: number;
  // Which backend the short code was actually created on (from useShortCode).
  // Poll that same backend rather than recomputing eligibility live — see
  // the comment in use-short-code-poll-status.ts for why (BKPE-27933).
  backend: OrderSelectionBackend;
}

export interface IUseShortCodePollStatus {
  pollingShortCodeStatus: ShortCodePollingStatus;
  resetPollingStatus: () => void;
}
